import React, { ReactElement } from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"

export type ProgressBadgeProps = {
  backgroundColor?: string
  color?: string
  text?: string
  dataCy?: string
  icon?: ReactElement
}

// Display either an icon with a circle around or a text with a circle around
export const ProgressBadge = (content: ProgressBadgeProps) => {
  const { color = theme.color.black3, icon, backgroundColor = theme.color.white, text, dataCy } = content
  const hasIcon = !!icon

  return (
    <Root $backgroundColor={backgroundColor} $color={color} $hasIcon={hasIcon} data-cy={dataCy}>
      {hasIcon ? <>{content.icon}</> : <StepText>{text}</StepText>}
    </Root>
  )
}

const Root = styled.div<{ $backgroundColor: string; $color: string; $hasIcon: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${theme.color.white1};
  border-radius: 50%;
  ${(p) =>
    css`
      background-color: ${p.$backgroundColor};
    `}
  ${(p) =>
    css`
      color: ${p.$color};
    `}
  ${(p) =>
    p.$hasIcon &&
    css`
      padding: ${theme.spacing.m};
    `}
`

const StepText = styled.span`
  font-size: ${theme.fontSize.s};
  font-weight: bold;
`
